import Layout from "../layouts/Layout";
import DashboardIcon from "@mui/icons-material/Dashboard";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import AddDestinationLocation from "../features/data-providers/add-destination-location/AddDestinationLocation";
import { Redirect1 } from "../features/duc/Redirect";
import { Redirect2 } from "../features/duc/Redirect";
import LockIcon from '@mui/icons-material/Lock';
import DUCpage from "../features/duc/DUCpage";
import DUCProcess from "../features/duc/DUCProcess";
import DataWrangler from "../features/new-data-wrangler/DataWrangler";
import HelpCenterPage from "../features/help-center/HelpCenterPage";
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import GlobusRedirect from "../features/globus/components/GlobusRedirect";
import FeedIcon from '@mui/icons-material/Feed';
import Publications from "../features/publications/Publications";
import NewPublication from "../features/publications/NewPublication";
import TrainingProcess from "../features/duc/TrainingProcess";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import ApprovedUsers from "../features/approved-users/ApprovedUsers";
import GlobusController from '../features/globus-collections/GlobusController';
import PIDashboard from "../features/duc/PIDashboard";
import { Roles } from "./Roles";
import VideosPage from "../features/help-center/VideosPage";
import DownloadToolsPage from "../features/download-tools/DownloadToolsPage";
import DownloadIcon from '@mui/icons-material/Download';
import CliInstructions from "../features/download-tools/CliInstructions";
import UserAccountsLayout from "../features/user-accounts/components/UserAccountsLayout";
import Dashboard from '../features/dashboard/Dashboard';
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import PreviousRelease from "../features/previous-release/components/PreviousRelease";

export const getPages = (onlyDuc: boolean): any[] => {
    return [
        {
            type: "path",
            element: Redirect1,
            path: "accounts/ducprocess/redirect",
        },
        {
            type: "path",
            element: Redirect2,
            path: "accounts/ducprocess/redirect2",
        },
        {
            type: "path",
            element: GlobusRedirect,
            path: "globus-redirect"
        },
        {
            type: "layout",
            element: Layout,
            disableWithKeycloak: false,
            children:
            [
                {
                    type: "index",
                    element: Dashboard,
                    sidebar: {
                        label: "Dashboard",
                        icon: DashboardIcon,
                        hoverTooltip: "View Dashboard"
                    },
                    public: true
                },
                {
                    type: "path",
                    element: DataWrangler,
                    path: "data-wrangler",
                    sidebar: {
                        // Hack for LC-2598 to rename sidebar label if you're not logged in
                        label: (user: any) => user.id === -1 ? "Data Dictionary" : "All Study Data Search & Filter",
                        icon: QueryStatsIcon,
                        hoverTooltip: "Search and filter study data"
                    },
                    public: true
                },
                {
                    type: "path",
                    element: ApprovedUsers,
                    path: "approved-users",
                    sidebar: {
                        label: "Approved User List",
                        icon: PeopleOutlineIcon,
                        hoverTooltip: "View approved applicants and sub-applicants on active DUCs"
                    },
                    public: true
                },
                {
                    type: "path",
                    element: DownloadToolsPage,
                    requiredRoles: ["ADMIN", "SUBJECT", "DUCREQUIRED", "TRAININGREQUIRED"] as Roles[],
                    sidebar: {
                        label: "Download Tools", icon: DownloadIcon,
                        hoverTooltip: "View and download tools"
                    },
                    path: "download-tools",
                },
                {
                    type: "path",
                    element: Publications,
                    requiredRoles: ["ADMIN", "SUBMISSION", "SUBJECT", "DUCREQUIRED", "TRAININGREQUIRED"] as Roles[],
                    path: "publications",
                    disabled: onlyDuc,
                    sidebar: { label: "NBDC Publications", icon: FeedIcon, hoverTooltip: "View NBDC Publications" },
                },
                {
                    type: "path",
                    element: UserAccountsLayout,
                    requiredRoles: ["ExternalAdmin"] as Roles[],
                    path: "user-accounts",
                    sidebar: {
                        label: "Study Admin Dashboard",
                        icon: PeopleAltIcon,
                    },
                },
                {
                    type: "path",
                    element: DUCpage,
                    requiredRoles: ["ADMIN", "SUBMISSION", "SUBJECT", "DUCREQUIRED", "TRAININGREQUIRED"] as Roles[],
                    path: "duc",
                    sidebar: { label: "Data Access (DUC)", icon: LockIcon },
                },
                {
                    type: "path",
                    element: HelpCenterPage,
                    requiredRoles: ["ADMIN", "SUBMISSION", "SUBJECT", "DUCREQUIRED", "TRAININGREQUIRED"] as Roles[],
                    path: "help-center",
                    disabled: onlyDuc,
                    sidebar: { label: "Help Center", icon: BookmarksIcon },
                },
                {
                    type: "path",
                    element: VideosPage,
                    requiredRoles: ["ADMIN", "SUBMISSION", "SUBJECT", "DUCREQUIRED", "TRAININGREQUIRED"] as Roles[],
                    path: "help-center/videos",
                    disabled: onlyDuc
                },
                {
                    type: "path",
                    element: DUCProcess,
                    requiredRoles: ["ADMIN", "SUBJECT", "DUCREQUIRED", "TRAININGREQUIRED"] as Roles[],
                    path: "duc/request",
                },
                {
                    type: "path",
                    element: PIDashboard,
                    requiredRoles: ["ADMIN", "PI"] as Roles[],
                    excludedRoles: ["DUCREQUIRED", "TRAININGREQUIRED"] as Roles[],
                    path: "duc/sub-applicants",
                },
                {
                    type: "path",
                    element: AddDestinationLocation,
                    requiredRoles: ["ADMIN", "SUBMISSION", "SUBJECT"] as Roles[],
                    path: "file-download/add",
                },
                {
                    type: "path",
                    element: NewPublication,
                    requiredRoles: ["ADMIN", "SUBMISSION", "SUBJECT"] as Roles[],
                    path: "publications/add",
                    disabled: onlyDuc
                },
                {
                    type: "path",
                    element: TrainingProcess,
                    requiredRoles: ["ADMIN", "SUBJECT", "SUBMISSION", "TRAININGREQUIRED"] as Roles[],
                    path: "duc/training",
                },
                {
                    type: "path",
                    element: GlobusController,
                    requiredRoles: ["ADMIN", "SUBJECT", "TRAININGREQUIRED"] as Roles[],
                    path: "globus-collections",
                    disabled: onlyDuc
                },
                (window.env?.openOnDemandURL || window.env?.openOnDemandOnPremiseURL ?
                    {
                        type: "path",
                        path: "safe",
                        requiredRoles: ["ADMIN", "SUBJECT", "SUBMISSION"] as Roles[],
                        sidebar: {
                            label: "Sandbox",
                            icon: OpenInNewIcon,
                            isDropdown: true
                        }
                    }
                    : {}
                ),
                {
                    type: "path",
                    element: CliInstructions,
                    requiredRoles: ["ADMIN", "SUBJECT", "TRAININGREQUIRED"] as Roles[],
                    path: "download-tools/cli",
                    disabled: onlyDuc
                },
                {
                    type: "path",
                    element: PreviousRelease,
                    sidebar: {
                        label: "Previous Releases",
                        icon: SimCardDownloadIcon,
                        hoverTooltip: "Download Previous Releases"
                    },
                    requiredRoles: ["ADMIN", "SUBJECT"] as Roles[],
                    path: "previous-release",
                    disabled: onlyDuc
                },
            ],
        },
    ];
};
